import React from 'react';
import {useNavigate} from 'react-router-dom';

import styles from './styles.module.scss';

export default function KnewRegionBrand() {
  const navigator = useNavigate();
  const RegionBrandList = [
    {
      title: '성수\n서울숲',
      path: '/brands/1/16',
    },
    {
      title: '용산\n삼각지',
      path: '/brands/1/21',
    },
    {
      title: '합정\n망원',
      path: '/brands/1/13',
    },
    {
      title: '압구정\n신사',
      path: '/brands/1/2',
    },
    {
      title: '서촌\n북촌',
      path: '/brands/1/23',
    },
    {
      title: '전체보기',
      path: '/brand',
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>지역별 브랜드</div>
      </div>
      <div className={styles.card_wrapper}>
        {RegionBrandList.map((item, index) => {
          return (
            <div
              className={styles.card}
              key={`regionBrand${index}`}
              onClick={() => {
                navigator(item.path, {
                  state: {
                    prev: 'home',
                  },
                  replace: true,
                });
              }}>
              <div className={styles.cardTitle}>
                {item.title}

                {index === 5 && (
                  <span className={`arrow-right-white-icon ${styles.icon}`} />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
